export default __webpack_public_path__ + "images/FW.421374f.png";